import { Component } from '@angular/core';

@Component({
    selector: 'app-security-code',
    templateUrl: './security-code.component.html',
    styleUrls: ['./security-code.component.scss'],
    standalone: false
})
export class SecurityCodeComponent {
    complete = false;
    code: number | undefined;

    constructor() {}

    onCodeCompleted(code: string) {
        this.complete = true;
        this.code = Number(code);
    }
}
